  const title = {
    fontSizeMobile: '16px',
    lineHeightMobile: '20px',
    fontWeight: '850',
    textTransform: 'uppercase',
    fontSizeDesktop: '24px',
    lineHeightDesktop: '30px',
  }

  const cta = {
    letterSpacing: '0.21px'
  }
  
  const paragraph = {
    fontWeight: '400',
  }
  
  const loyaltyBanner = {
    title,
    cta,
    paragraph
  }

  export default loyaltyBanner